import { Box, Container, Typography } from "@mui/material";

export const GenericBanner = () => (
  <Box
    component="section"
    className="default-bg"
    pt={{ xs: 3, sm: 4, md: 5, lg: 10 }}
    pb={{ xs: 4, sm: 5, md: 7, lg: 12 }}
  >
    <Container>
      <Box
        mb={{ xs: 2.25, sm: 3, md: 2.25 }}
        width={{ sm: 428, md: "unset" }}
        margin="auto"
      >
        <Typography variant="h3" component="h2" align="center">
          The global fight against cancer requires advanced molecular detection
          products that are accurate, actionable, easy-to-use and available
          worldwide.
        </Typography>
      </Box>
      <Box width={{ xs: "unset", sm: 428, md: 759 }} margin="auto">
        <Typography variant="subtitle1" component="p" align="center">
          We provide a powerful product development platform for research that
          enables all molecular laboratories to solve complex genomic problems.
        </Typography>
      </Box>
    </Container>
  </Box>
);
